import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  actions: {
    getHolidays: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/holidays/');

      return result.response;
    },

    updateHoliday: async ({ commit, getters }, data) => {
      const result = await statusHandler.authPut({ commit, getters }, '/api/holidays/', { data });
      return result;
    },

    deleteHoliday: async ({ commit, getters }, data) => {
      const result = await statusHandler.authDelete({ commit, getters }, '/api/holidays/', { data });

      return result.response;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/holiday.js